import React                   from 'react'
import UtilHelper from '../../util/util-helper'
import { loginApiUrl, clientId, redirectUri} from '../../actions/config'
import { initGA, logPageView, trackingEvent } from "./layouts/GoogleAnalytics.js"
import CodeVerifierHelper from '../../util/code-verifier-helper';
import BuildParamsHelpers from '../../util/build-params-helper'

class Landing extends React.Component {
  componentWillMount () {
    if (!window.GA_INITIALIZED) {
      initGA()
      window.GA_INITIALIZED = true
    }
    logPageView()
  }

  trackingServiceList(event) {
    trackingEvent("Top", "サービス一覧")
    UtilHelper.toogleClassByAttribute(event, "data-active", "lp_service_list_menu", "lp_service_list", "show")
  }

  trackingLogin() {
    trackingEvent("Top", "ログイン")
    this.clickedLogin()
  }

  async clickedLogin() {
    const params = await this.buildLoginParams()
    window.location.href = `${loginApiUrl}oauth/authorize?` + params
  }

  async buildLoginParams() {
    const codeChallenge =  await this.buildCodeChallenge()

    const params = {
      client_id: clientId,
      code_challenge: codeChallenge,
      code_challenge_method: 'S256',
      response_type: 'code',
      prompt: 'login',
      scope: 'openid%20email',
      redirect_uri: encodeURIComponent(redirectUri)
    }

    return BuildParamsHelpers.buildGetParams(params)
  }

  async buildCodeChallenge() {
    const verifier = CodeVerifierHelper.generateRandomString()
    window.sessionStorage.setItem("code_verifier", verifier)
    return await CodeVerifierHelper.challengeFromVerifier(verifier)
  }

  render() {
    const refSite = 'https://biz.moneyforward.com/'

    return (
      <main>
        <nav className="navbar navbar-light static-top lp-nav-login">
          <div className="container">
            <a className="navbar-brand lp-logo" href="/">
              <img src={require('../../../assets/images/logo-horizontal.png')} className="img-fluid" alt="logo.png"/>
            </a>
            <button className="btn btn-primary lp-login" type="button" onClick={() => this.trackingLogin()}>ログイン</button>
          </div>
        </nav>

        <header className="masthead text-white text-center">
          <div className="container">
            <div className="row">
              <div className="col-xl-9 mx-auto">
                <h6 className="mb-4 font-medium">取引明細をワンストップで管理する</h6>
                <h1 className="font-medium">マネーフォワード 明細連携</h1>
              </div>
            </div>
          </div>
        </header>

        <section className="linkage">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 text-right">
                <div className="p-5 left">
                  <img className="img-fluid" src={require('../../../assets/images/lp/macbook.png')}
                       srcSet={`${require('../../../assets/images/lp/macbook@2x.png')} 2x, ${require('../../../assets/images/lp/macbook@3x.png')} 3x`}
                       alt="macbook.png"/>
                </div>
              </div>
              <div className="col-md-6">
                <div className="p-5 right">
                  <h2 className="font-medium">マネーフォワード 明細連携とは</h2>
                  <p className="lp-gray-color mw-462">マネーフォワード
                    明細連携は、金融機関の取引明細を自動で取得できるサービスです。導入により取引明細を他のWebシステムや貴社の基幹システムに自動取り込みできます。</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section-one text-center mt-5 mb-5">
          <div className="container">
            <h4 className="mb-3 font-medium">取引明細をワンストップで管理</h4>
            <p className="mb-3 lp-gray-color">手作業やCSVで取り込んでいた取引明細の取り込みを自動化し、お客様の業務を効率化します。</p>
            <div className="row">
              <div className="col-lg-12">
                <div className="testimonial-item mx-auto mb-5 mb-lg-0">
                  <img className="img-fluid" src={require('../../../assets/images/lp/section-1.png')}
                       srcSet={`${require('../../../assets/images/lp/section-1@2x.png')} 2x, ${require('../../../assets/images/lp/section-1@3x.png')} 3x`}
                       alt="section-1.png"/>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section-two text-center mt-5 mb-5 pt-5 pb-5">
          <div className="container">
            <h4 className="mb-4 font-medium">マネーフォワード 明細連携の特徴</h4>
            <div className="row justify-content-center">
              <div className="col-sm-4">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title mt-2 mb-1 font-medium">3000行以上の</h5>
                    <h5 className="card-title mb-4 font-medium">金融機関と連携</h5>
                    <img className="img-fluid mb-4" src={require('../../../assets/images/lp/section-2-1.png')}
                         srcSet={`${require('../../../assets/images/lp/section-2-1@2x.png')} 2x, ${require('../../../assets/images/lp/section-2-1@3x.png')} 3x`}
                         alt="section-2-1.png"/>
                    <p className="card-text text-left">連携できる金融機関は3000行以上。国内ほぼ全ての銀行と連携可能です。<a
                      href="https://statement.moneyforward.com/" target="_blank" rel="noopener noreferrer"><i
                      className="fas fa-external-link-alt"></i>対応金融機関一覧</a></p>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title mt-2 mb-1 font-medium">金融機関レベルの</h5>
                    <h5 className="card-title mb-4 font-medium">強固なセキュリティ</h5>
                    <img className="img-fluid mb-4" src={require('../../../assets/images/lp/section-2-2.png')}
                         srcSet={`${require('../../../assets/images/lp/section-2-2@2x.png')} 2x, ${require('../../../assets/images/lp/section-2-2@3x.png')} 3x`}
                         alt="section-2-2.png"/>
                    <p className="card-text text-left">お客様のメールアドレスや口座へのアクセス情報は暗号化して厳重に管理しています。</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section-three text-center mt-5 mb-5">
          <div className="container">
            <h4 className="mb-3 font-medium">様々な用途でのご利用が可能</h4>
            <p className="mb-4 lp-gray-color">マネーフォワード明細連携は様々なシーンでご利用いただくことができます。</p>
            <div className="row">
              <div className="col-sm-4">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title mt-2 mb-1 font-medium">会計ソフトと連携して</h5>
                    <h5 className="card-title mb-4 font-medium">自動で仕訳起票</h5>
                    <img className="img-fluid mb-4" src={require('../../../assets/images/lp/section-3-1.png')}
                         srcSet={`${require('../../../assets/images/lp/section-3-1@2x.png')} 2x, ${require('../../../assets/images/lp/section-3-1@3x.png')} 3x`}
                         alt="section-3-1.png"/>
                    <p className="card-text text-left">会計ソフトと連携することで、ソフトに自動で取引明細を取り込み、その情報をもとに仕訳起票を行います。</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title mt-2 mb-1 font-medium">消込ソフトと連携して</h5>
                    <h5 className="card-title mb-4 font-medium">自動で入金消し込み</h5>
                    <img className="img-fluid mb-4" src={require('../../../assets/images/lp/section-3-2.png')}
                         srcSet={`${require('../../../assets/images/lp/section-3-2@2x.png')} 2x, ${require('../../../assets/images/lp/section-3-2@3x.png')} 3x`}
                         alt="section-3-2.png"/>
                    <p className="card-text text-left">消込ソフトと連携することで、ソフトに自動で入金情報を取得し、その情報をもとに消込を行います。</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title mt-2 mb-1 font-medium">口座残高を一元管理</h5>
                    <h5 className="card-title mt-2 mb-1">&nbsp;</h5>
                    <img className="img-fluid mb-4" src={require('../../../assets/images/lp/section-3-3.png')}
                         srcSet={`${require('../../../assets/images/lp/section-3-3@2x.png')} 2x, ${require('../../../assets/images/lp/section-3-3@3x.png')} 3x`}
                         alt="section-3-3.png"/>
                    <p className="card-text text-left">複数の法人口座の残高、明細管理を一括で行えます。またワンクリックで全ての口座の最新データを取得できます。</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section-four text-center mt-5 mb-5 pt-5 pb-5">
          <div className="container">
            <h4 className="mb-5 font-medium">システム概要図</h4>
            <div className="row">
              <div className="col-lg-12">
                <div className="testimonial-item mx-auto mb-5 mb-lg-0">
                  <img className="img-fluid" src={require('../../../assets/images/lp/section-4.png')}
                       srcSet={`${require('../../../assets/images/lp/section-4@2x.png')} 2x, ${require('../../../assets/images/lp/section-4@3x.png')} 3x`}
                       alt="section-4.png"/>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="footer-head-container">
          <div className="footer-general-container">
            <ul className="footer-breadcrumbs">
              <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb"><a itemProp="url" href={`${refSite}`}><span itemProp="title">マネーフォワード クラウド</span></a></li>
              <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb"><button itemProp="url" className="btn-link" ><span itemProp="title">マネーフォワード 明細連携</span></button></li>
            </ul>
          </div>
        </div>

        <div className="footer-foot-container">
          <div className="footer-general-container">
            <ul className="list-links">
              <li><a target="_blank" href="https://corp.moneyforward.com/" rel="noopener noreferrer" onClick={() => trackingEvent("Top", "運営会社情報")}>運営会社情報</a></li>
              <li><a target="_blank" href="https://corp.moneyforward.com/privacy/" rel="noopener noreferrer" onClick={() => trackingEvent("Top", "個人情報保護方針")}>個人情報保護方針</a></li>
              <li><a target="_blank" href="https://corp.moneyforward.com/security_policy/" rel="noopener noreferrer" onClick={() => trackingEvent("Top", "情報セキュリティ基本方針")}>情報セキュリティ基本方針</a></li>
              <li><a rel="nofollow" href={`${refSite}agreement`} onClick={() => trackingEvent("Top", "利用規約")}>利用規約</a></li>
              <li><a href={`${refSite}scta_notation`} onClick={() => trackingEvent("Top", "特定商取引に関する法律に基づく表記")}>特定商取引に関する法律に基づく表記</a></li>
            </ul>
            <div className="text-center">© Money Forward, Inc</div>
          </div>
        </div>
      </main>
    )
  }
}

export default Landing
